import { render, staticRenderFns } from "./ContractorItem.vue?vue&type=template&id=5ca71193&"
import script from "./ContractorItem.vue?vue&type=script&lang=js&"
export * from "./ContractorItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports